<template>
  <div class="home">
    <div class="grid-wrapper">
      <section class="hero span-12"><hero /></section>
      <section class="powered span-12"><power /></section>
      <section class="details span-12"><detail /></section>
      <section class="zippo span-12"><zippo /></section>
      <section class="services span-12"><services /></section>
      <!-- <section class="fishing span-12">fishing</section> -->
      <section class="mockup span-12"><mockup /></section>
      <section class="contact span-12"><contact /></section>
    </div>
  </div>
</template>
<script>
import services from "@/components/Services.vue";
import hero from "@/components/Header.vue";
import power from "@/components/PoweredBy.vue";
import detail from "@/components/Details.vue";
import zippo from "@/components/Zippo.vue";
import mockup from "@/components/Mockup.vue";
import contact from "@/components/Contact.vue";

export default {
  components: {
    services,
    hero,
    power,
    detail,
    zippo,
    mockup,
    contact,
  },
  setup() {
    return {};
  },
};
</script>

<style scoped>
.grid-wrapper {
  display: grid;
}
.span-12 {
  grid-column: span 12;
}
.hero {
  background-color: rgb(0, 0, 0);
}

.details {
  font-family: "Kanit", sans-serif;

  background-color: #c7e2e6;
}
</style>